import { PlusIcon } from '~/components/Abstracts/Icons'
import css from '~/components/UI/ProductCard/ProductCardQuickBuy/styles.module.scss'

export function Icon() {
  return <PlusIcon className={css.icon} />
}
